import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { COLORS, Col, FlexView, Row, Separator, Text } from '@cuemath/comps';
import { CopyButton } from 'comps';
import BallLoader from 'comps/ball-loader';
import { CET_TEST_TYPE } from 'constants/teacher-details';
import LAYOUT from 'constants/layout';
import useLogic from './logic';
import { LicenseCard } from './components';

const CustomLink = styled.a`
  color: ${COLORS.BOSTON_BLUE};
  font-size: ${LAYOUT.GUTTER};
  :visited {
    color: ${COLORS.PURPLE};
  }
  :hover {
    color: blue;
  }
`;

const TeacherLicense = () => {
  const { tests, licenses, regions, isLoading } = useLogic();

  if (isLoading) {
    return (
      <FlexView>
        <Separator height={48} />
        <BallLoader />
      </FlexView>
    );
  }

  return (
    <FlexView>
      <Text
        variant="eyebrow2"
        color={COLORS.COLA_LIGHTER}
      >{`Licenses (${licenses?.length})`}</Text>
      <Separator height={8} transparent />
      {licenses?.length > 0 ? (
        licenses?.map(
          ({
            scheme_category: id,
            scheme_category_name: program,
            license_scheme_list: categoryList,
          }) => (
            <LicenseCard
              key={id}
              id={id}
              licenses={licenses}
              program={program}
              geos={regions}
              categoryList={categoryList}
            />
          ),
        )
      ) : (
        <div>No Licenses found</div>
      )}
      <Separator height={24} transparent />
      <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
        Test Summary
      </Text>
      <Separator height={8} transparent />
      {tests?.length > 0 ? (
        <Row justifyContent="space-between">
          {tests?.map((testItem, i) => {
            const {
              cet_type: testType,
              status,
              created_on: createdOn,
              registration_status: registrationStatus,
              url,
              grade_group: gradeGroup,
              id: testId,
            } = testItem;
            const testLink =
              testType === CET_TEST_TYPE.SOP ? url : registrationStatus?.[0]?.url;

            return (
              <Col key={i} gutter={0} gap={0}>
                <Separator height={12} transparent />
                <Text variant="cta2">{testType}</Text>
                <Separator height={4} transparent />
                <CopyButton copyMessage="Test ID" text={testId} />
                <Separator height={4} transparent />
                <Text variant="body2">
                  Test Date: {format(createdOn * 1000, 'D MMM, YY h:mm a')}
                </Text>
                <Separator height={4} transparent />
                <Text variant="body2">Status: {status}</Text>
                {!!gradeGroup && (
                  <>
                    <Separator height={4} transparent />
                    <Text variant="body2">Grade Group: {gradeGroup}</Text>
                  </>
                )}
                {!!testLink && (
                  <>
                    <Separator height={4} transparent />
                    <CustomLink href={testLink} target="_blank" rel="noopener noreferrer">
                      Test Link
                    </CustomLink>
                  </>
                )}
                <Separator height={12} transparent />
              </Col>
            );
          })}
        </Row>
      ) : (
        <div>No test results found</div>
      )}
    </FlexView>
  );
};

export default TeacherLicense;
